// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"dd41ba35ef20a9f4e371","245":"c4b8818e4ed5e07d7a5a","453":"f5a1ede2583025b46c55"}[chunkId] + ".js";
};